import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO COMPONENT - Micheals Infrastructure Advisory
 * Strategic Shift: National Advisory & Forensic Technical Governance.
 */
const SEO = ({ 
  title, 
  description, 
  schema, 
  path = "", 
  image = "/assets/logo.webp", 
  services = [] 
}) => {
  const baseUrl = "https://medconsulting.solutions"; 
  const fullUrl = `${baseUrl}${path}`;
  const ogImage = image.startsWith('http') ? image : `${baseUrl}${image}`;
  
  const siteName = "Micheals Infrastructure Advisory";
  const highEndDescription = description || "Principal Infrastructure Consulting, Forensic Auditing, and Strategic System Design for Premium Estates and Commercial Developments Nationwide.";

  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService", // Changed from ConsultingBusiness to ProfessionalService for broader authority
    "@id": `${baseUrl}/#organization`, 
    "name": siteName,
    "url": baseUrl,
    "logo": `${baseUrl}/assets/logo.webp`, 
    "image": ogImage,
    "description": highEndDescription,
    "telephone": "+17044914000",
    "priceRange": "$$$$",
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "13801 Reese Blvd West",
      "addressLocality": "Huntersville", 
      "addressRegion": "NC",
      "postalCode": "28078",
      "addressCountry": "US"
    },
    // Adding sameAs helps Google verify your entity authority
    "sameAs": [
        "https://www.linkedin.com/company/med-consulting-solutions" // Update with your actual URL
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Architectural Governance & Advisory Suite",
      "itemListElement": services.map((s, i) => ({
        "@type": "ListItem",
        "position": i + 1,
        "item": {
          "@type": "Service",
          "name": s,
          "description": `Technical forensic oversight and architectural strategy for ${s}.`,
          "provider": { "@id": `${baseUrl}/#organization` }
        }
      }))
    }
  };

  return (
    <Helmet>
      <title>{title ? `${title} | ${siteName}` : siteName}</title>
      <meta name="description" content={highEndDescription} />
      <link rel="canonical" href={fullUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title ? `${title} | ${siteName}` : siteName} />
      <meta property="og:description" content={highEndDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title ? `${title} | ${siteName}` : siteName} />
      <meta name="twitter:description" content={highEndDescription} />
      <meta name="twitter:image" content={ogImage} />

      <script type="application/ld+json">
        {JSON.stringify(schema || defaultSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;